import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import TextInput from 'modules/core/components/Inputs/Text'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'
import app from 'modules/core/store/models/app'

import { ActivatePayload } from 'modules/app_store/lib/SubscriptionAddonInstaller'
import { MAX_REGULAR_ACCESS_DELAY_DAYS } from 'modules/app_store/lib/constants'

interface Props {
  onSuccess: (payload?: ActivatePayload | null | undefined) => Promise<boolean>
  onClose: () => void
}

class CreateCompanyForm extends Form {
  constructor(values: object) {
    super(values, {
      regular_access_delay_in_days: 'number',
    })
  }
}

const ActivateEmployeeOnboardingModal = ({ onSuccess, onClose }: Props) => {
  const [inputValue, setInputValue] = React.useState<number>(
    companies.current.attributes.regular_access_delay_in_days
  )

  const handleOnChangeCustomDate = (days: number) => {
    setInputValue(days || 0)
    form
      .get('regular_access_delay_in_days')
      .setErrors(
        days > MAX_REGULAR_ACCESS_DELAY_DAYS
          ? [
              i18n.t(
                'app_store_v2.apps.employee_onboarding.settings_default_date.custom_date_error'
              ),
            ]
          : null
      )
  }

  const onSubmit = async () => {
    const success = await onSuccess({
      regular_access_delay_in_days: inputValue,
    })

    if (!success) {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_saving'),
      })
    }
  }

  const form = React.useRef(new CreateCompanyForm(companies.current.toJS())).current

  return (
    <Modal
      illustration="calendar-clock"
      title={i18n.t('app_store_v2.apps.employee_onboarding.settings_install_modal.title')}
      description={i18n.t(
        'app_store_v2.apps.employee_onboarding.settings_install_modal.description'
      )}
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Button disabled={!!form.hasErrors} submit>
          {i18n.t('app_store_v2.apps.employee_onboarding.settings_install_modal.submit')}
        </Button>
      }
    >
      <Box flexDirection="row" alignItems="baseline" gap="s8">
        <Box width="s120">
          <TextInput
            type="number"
            field={form.get('regular_access_delay_in_days')}
            onChange={(e) => handleOnChangeCustomDate(parseInt(e.value))}
            min={0}
          />
        </Box>
        <Text.Normal size="200" color="grey800" weight="medium">
          {i18n.t('app_store_v2.apps.employee_onboarding.settings_install_modal.sub_description')}
        </Text.Normal>
      </Box>
    </Modal>
  )
}

export default observer(ActivateEmployeeOnboardingModal)
